import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { ReturnPolicy } from '../../models/warranty-type/warranty-model';
import { ProductService } from '../../services/product/product.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-return-policy-create',
    templateUrl: './return-policy-create.component.html',
    styleUrls: ['./return-policy-create.component.css']
})
/** return-policy-create component*/
export class ReturnPolicyCreateComponent {
    /** return-policy-create ctor */
  public returnPolicy = new ReturnPolicy();
  validate: boolean;
  constructor(private readonly productService: ProductService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("returnPolicy").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {

            this.toastr.setRootViewContainerRef(vcr);
            this.returnPolicy.isActive = true;
            this.validate = true;
          }
          else {
            this.router.navigate(["/warranty-list"]);
          }
        }
        else {
          this.router.navigate(["/warranty-list"]);
        }
      }
    )

  }
  isActiveCheckbox(e) {
    this.returnPolicy.isActive = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.productService.addReturnPolicy(this.returnPolicy).subscribe(result => {
      if (result) {
        this.toastr.success('Return Policy has been Saved.', 'Success');
        setTimeout(() => {
          this.router.navigate(["/returnPolicy-list"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/return-policy/return-policy-create/return-policy-create.component.ts